import React, { useState } from 'react';
import './Reviews.css';

const Reviews = ({ reviews }) => {
  const [selectedReview, setSelectedReview] = useState(null);

  const openModal = (review) => {
    setSelectedReview(review);
  };

  const closeModal = () => {
    setSelectedReview(null);
  };

  return (
    <div className="reviews-container">
      <h3></h3>
      <div className="reviews-scroll">
        {reviews.length === 0 ? (
          <p>No reviews available</p>
        ) : (
          reviews.map((review, index) => {
            const text = review.review || review.content || 'No review text available';
            const user = review.user?.username || review.user?.name || 'Anonymous';
            const profileImage =
              review.user?.images?.jpg?.image_url || 'https://via.placeholder.com/50';
            const rating = review.score || 'No rating';

            return (
              <div className="review-card" key={index} onClick={() => openModal({ text, user, rating, profileImage })}>
  {/* Profile Image */}
  <img src={profileImage} alt={user} className="profile-image" />

  {/* Text Container */}
  <div className="review-text-container">
    <p className="review-text">
      {text.length > 80 ? `${text.substring(0, 80)}...` : text}
    </p>
  </div>

  {/* Reviewer Info */}
  <div className="review-info">
    <span className="review-user">{user}</span>
    <span className="review-rating">{rating} ⭐</span>
  </div>
</div>

            );
          })
        )}
      </div>

      {/* Full Review Modal */}
      {selectedReview && (
        <div className="review-modal-overlay" onClick={closeModal}>
          <div className="review-modal" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal" onClick={closeModal}>
              &times;
            </button>
            <div className="modal-header">
              <img
                src={selectedReview.profileImage}
                alt={selectedReview.user}
                className="modal-profile-image"
              />
              <h3 className="modal-user">{selectedReview.user}</h3>
            </div>
            <p className="modal-review-text">“{selectedReview.text}”</p>
            <span className="modal-rating">Rating: {selectedReview.rating} ⭐</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Reviews;
